import { Splide, SplideSlide } from '@splidejs/vue-splide'

export default {
  components: {
    Splide,
    SplideSlide
  },

  props: {
    speedDuration: {
      type: String
    },
    allowScrollSpeed: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      splideOptions: {
        arrows: false,
        pagination: false,
        updateOnMove: true,
        perPage: 5,
        focus: 'center',
        drag: true,
        rewind: false,
        gap: '20px',
        type: 'loop',
        autoplay: this.allowScrollSpeed,
        interval: this.speedDuration,
        pauseOnFocus: false,
        pauseOnHover: false,
        direction: 'ltr',
        waitForTransition: true,
        easing: 'ease',
        wheel: true,
        breakpoints: {
          768: {
            perPage: 2,
            padding: { left: '15%', right: '15%' },
            focus: 'center',
            type: 'loop',
            drag: true
          },
          640: {
            perPage: 1.2,
            padding: { left: '15%', right: '15%' },
            focus: 'center',
            type: 'loop',
            drag: true
          }
        }
      }
    }
  }
}
